<div class="header-cell">
    <!-- <span *ngIf="isWorkflowHeaderCell" class="workflow-header-text" mat-sort-header [title]="column.header">{{ column.header }} </span>

  <div *ngIf="isFilterHeaderCell" matSuffix class="filter-suffix">
    <span class="header-text sort-icon" mat-sort-header [title]="column.header" (click)="$event.stopPropagation();$event.preventDefault();">{{ column.header }}</span>
  </div> -->
    <span class="header-text" mat-sort-header [disabled]="column.type === PropertyType.Workflow || disabledSort || column.propertyCode === 'systemIcons'" [title]="column.header">
        {{ column.header }}
    </span>
</div>
